import { render, staticRenderFns } from "./PurchaseList.vue?vue&type=template&id=4a0e1e8a&scoped=true"
import script from "./PurchaseList.vue?vue&type=script&lang=js"
export * from "./PurchaseList.vue?vue&type=script&lang=js"
import style0 from "./PurchaseList.vue?vue&type=style&index=0&id=4a0e1e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0e1e8a",
  null
  
)

export default component.exports